var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x37_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 4c-6.6098633 0-12 5.3900146-12 12 0 6.6199951 5.3901367 12 12 12 6.6201172 0 12-5.3800049 12-12 0-6.6099854-5.3798828-12-12-12zm5.9301758 11.4700317-2.4101563 1.75.9199219 2.8299561c.1699219.5499878-.0200195 1.1400146-.4799805 1.4700317-.4599609.3399658-1.0898438.3399658-1.5498047 0l-2.4101562-1.75-2.3999023 1.75c-.4918718.3480339-1.0821419.3452854-1.550293 0-.4599609-.3300171-.659668-.9200439-.4799805-1.4700317l.9204102-2.8299561-2.4101563-1.75c-.4599609-.3400268-.6499023-.9300537-.4799804-1.4700317.1801758-.539978.6801758-.9099731 1.25-.9099731h2.9799805l.9199218-2.8300171c.1801758-.5499878.6801758-.9100342 1.25-.9100342h.0102539c.5698242 0 1.0698242.3600464 1.25.9100342l.9199219 2.8300171h2.9697266c.5800781 0 1.0800781.3699951 1.2602539.9099731.1699218.539978-.0200196 1.1300049-.4799805 1.4700317z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.891151bf3ae53de151be146a6bd3519a.svg";
export { ForwardRef as ReactComponent };